(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[674],{

/***/ 7656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3815)


/***/ }),

/***/ 4490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var _hook_useWindowSize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8766);
/* harmony import */ var _business_button_business_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2955);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3203);
/* harmony import */ var _back_to_latest_article_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4189);
/* harmony import */ var _back_to_latest_article_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_back_to_latest_article_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const BackToLatestArticle = (props)=>{
    const { latestArticleUrl  } = props;
    const windowSize = (0,_hook_useWindowSize__WEBPACK_IMPORTED_MODULE_2__/* .useWindowSize */ .i)();
    const isMobile = ()=>{
        const windowWidth = windowSize.width || 0;
        if (windowWidth < 768) {
            return true;
        } else {
            return false;
        }
    };
    // TODO standardise where latest articles page is.
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: latestArticleUrl,
        target: "_self",
        className: (_back_to_latest_article_module_scss__WEBPACK_IMPORTED_MODULE_5___default().backToLatestArticle),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_business_button_business_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: isMobile() ? "small" : "normal",
            color: "white",
            buttonText: "Back to access",
            icon: _icons__WEBPACK_IMPORTED_MODULE_4__/* .IconType.ArrowRightMedium */ .T.ArrowRightMedium
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BackToLatestArticle);


/***/ }),

/***/ 83:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);


const AuthorAvatar = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "88",
        height: "88",
        viewBox: "0 0 88 88",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "44",
                cy: "44",
                r: "44",
                fill: "#B2FCE4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M44 45.75C48.8325 45.75 52.75 41.8325 52.75 37C52.75 32.1675 48.8325 28.25 44 28.25C39.1675 28.25 35.25 32.1675 35.25 37C35.25 41.8325 39.1675 45.75 44 45.75Z",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M61.3351 63.6741C59.7699 60.4037 57.3115 57.6429 54.2441 55.7102C51.1767 53.7775 47.6251 52.752 43.9996 52.752C40.374 52.752 36.8224 53.7775 33.7549 55.7102C30.6874 57.6429 28.2292 60.4037 26.6641 63.6741",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M44 70.25C58.4973 70.25 70.25 58.4973 70.25 44C70.25 29.5025 58.4973 17.75 44 17.75C29.5025 17.75 17.75 29.5025 17.75 44C17.75 58.4973 29.5025 70.25 44 70.25Z",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AuthorAvatar);


/***/ }),

/***/ 6094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var _business_article_bio_block_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8737);
/* harmony import */ var _business_article_bio_block_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_business_article_bio_block_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _IconAuthorAvatar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83);




const ArticleBioBlock = (props)=>{
    const { articleAuthor  } = props;
    const renderAuthorAvatar = ()=>{
        if (!(articleAuthor === null || articleAuthor === void 0 ? void 0 : articleAuthor.leadImage) || (articleAuthor === null || articleAuthor === void 0 ? void 0 : articleAuthor.leadImage) === "") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_IconAuthorAvatar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_business_article_bio_block_module_scss__WEBPACK_IMPORTED_MODULE_3___default().businessArticleLeadImage),
            style: {
                backgroundImage: "url('".concat(articleAuthor === null || articleAuthor === void 0 ? void 0 : articleAuthor.leadImage, "')")
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_business_article_bio_block_module_scss__WEBPACK_IMPORTED_MODULE_3___default().businessArticleBioContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_business_article_bio_block_module_scss__WEBPACK_IMPORTED_MODULE_3___default().businessArticleAuthorAvatar),
                children: renderAuthorAvatar()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_business_article_bio_block_module_scss__WEBPACK_IMPORTED_MODULE_3___default().businessArticleInfo),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_business_article_bio_block_module_scss__WEBPACK_IMPORTED_MODULE_3___default().writtenBy),
                        children: "Written by"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_business_article_bio_block_module_scss__WEBPACK_IMPORTED_MODULE_3___default().name),
                        children: articleAuthor === null || articleAuthor === void 0 ? void 0 : articleAuthor.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_business_article_bio_block_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bio),
                        children: articleAuthor === null || articleAuthor === void 0 ? void 0 : articleAuthor.bio
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleBioBlock);


/***/ }),

/***/ 3770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2991);
/* harmony import */ var _contexts_DefaultLayoutContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1683);
/* harmony import */ var _categories_categories__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8324);
/* harmony import */ var _business_article_categories_block_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7053);
/* harmony import */ var _business_article_categories_block_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_business_article_categories_block_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const ArticleCategoriesBlock = (props)=>{
    const { categories  } = props;
    const defaultLayoutContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_contexts_DefaultLayoutContext__WEBPACK_IMPORTED_MODULE_3__/* .DefaultLayoutContext */ .V);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_business_article_categories_block_module_scss__WEBPACK_IMPORTED_MODULE_5___default().articleCategoriesContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_business_article_categories_block_module_scss__WEBPACK_IMPORTED_MODULE_5___default().categoriesHeading), (_business_article_categories_block_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[defaultLayoutContext.type || ""]),
                children: "Categories"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_categories_categories__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                type: "LARGE",
                categories: categories,
                color: defaultLayoutContext.type === "light" ? "white" : "grey"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleCategoriesBlock);


/***/ }),

/***/ 9948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2991);
/* harmony import */ var _business_button_business_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2955);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3203);
/* harmony import */ var _business_article_contributor_block_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2288);
/* harmony import */ var _business_article_contributor_block_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_business_article_contributor_block_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _business_article_bio_block_IconAuthorAvatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83);







const ArticleContributorBlock = (props)=>{
    const { contributors , hasAuthorBefore  } = props;
    const renderAuthorAvatar = (contributor)=>{
        if (!(contributor === null || contributor === void 0 ? void 0 : contributor.leadImage) || (contributor === null || contributor === void 0 ? void 0 : contributor.leadImage) === "") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_business_article_bio_block_IconAuthorAvatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_business_article_contributor_block_module_scss__WEBPACK_IMPORTED_MODULE_6___default().businessArticleLeadImage),
            style: {
                backgroundImage: "url('".concat(contributor === null || contributor === void 0 ? void 0 : contributor.leadImage, "')")
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_business_article_contributor_block_module_scss__WEBPACK_IMPORTED_MODULE_6___default().businessArticleContributorListContainer), {
            [(_business_article_contributor_block_module_scss__WEBPACK_IMPORTED_MODULE_6___default().hasAuthorBefore)]: hasAuthorBefore
        }),
        children: contributors === null || contributors === void 0 ? void 0 : contributors.map((contributor)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_business_article_contributor_block_module_scss__WEBPACK_IMPORTED_MODULE_6___default().businessArticleContributorContainer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_business_article_contributor_block_module_scss__WEBPACK_IMPORTED_MODULE_6___default().businessArticleContributorAvatar),
                        children: renderAuthorAvatar(contributor)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_business_article_contributor_block_module_scss__WEBPACK_IMPORTED_MODULE_6___default().businessArticleInfo),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_business_article_contributor_block_module_scss__WEBPACK_IMPORTED_MODULE_6___default().writtenBy),
                                children: "Contributed by"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_business_article_contributor_block_module_scss__WEBPACK_IMPORTED_MODULE_6___default().name),
                                children: contributor === null || contributor === void 0 ? void 0 : contributor.name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_business_article_contributor_block_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bio),
                                children: contributor === null || contributor === void 0 ? void 0 : contributor.bio
                            }),
                            contributor.ctaText && contributor.ctaUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_business_article_contributor_block_module_scss__WEBPACK_IMPORTED_MODULE_6___default().cta),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_business_button_business_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    size: "small",
                                    icon: _icons__WEBPACK_IMPORTED_MODULE_4__/* .IconType.ArrowRightSmall */ .T.ArrowRightSmall,
                                    buttonText: contributor.ctaText,
                                    link: contributor.ctaUrl
                                })
                            }) : null
                        ]
                    })
                ]
            }, contributor.name);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleContributorBlock);


/***/ }),

/***/ 8916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ business_share_icons; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(5630);
// EXTERNAL MODULE: ./components/business-share-icons/business-share-icons.module.scss
var business_share_icons_module = __webpack_require__(6908);
var business_share_icons_module_default = /*#__PURE__*/__webpack_require__.n(business_share_icons_module);
;// CONCATENATED MODULE: ./components/business-share-icons/social-and-share-icon/facebook-social.tsx


const FacebookSocial = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.1495 17.8596C21.1495 17.7349 21.1668 17.4657 21.2014 17.0535C21.2386 16.6406 21.3945 16.2086 21.6741 15.7549C21.9511 15.303 22.4005 14.8969 23.0256 14.5376C23.648 14.1801 24.5476 14 25.7215 14H29.0288V17.6042H26.6072C26.3674 17.6042 26.144 17.6942 25.9423 17.8717C25.7423 18.0492 25.6393 18.218 25.6393 18.3747V20.617H29.0279C28.9924 21.056 28.9534 21.4828 28.9084 21.8949L28.7742 22.984C28.7206 23.352 28.666 23.6931 28.6123 24.0074H25.6151V34H21.1495V24.0065H18.9712V20.617H21.1495V17.8596Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                stroke: "#EFF4FB"
            })
        ]
    });
};
/* harmony default export */ var facebook_social = (FacebookSocial);

;// CONCATENATED MODULE: ./components/business-share-icons/social-and-share-icon/linkedIn-social.tsx


const LinkedInSocial = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.6705 15.0739C15.1177 14.653 15.7014 14.4424 16.4218 14.4424C17.1423 14.4424 17.7197 14.6529 18.1536 15.0739C18.5875 15.4949 18.809 16.0265 18.8177 16.6689C18.8263 17.3026 18.6071 17.8321 18.1602 18.2573C17.7132 18.6828 17.125 18.8954 16.3957 18.8954H16.3697C15.6579 18.8954 15.0849 18.6826 14.651 18.2573C14.217 17.8321 14 17.3024 14 16.6689C14 16.0264 14.2234 15.4949 14.6705 15.0739ZM32.6458 21.832C31.7432 20.8467 30.5494 20.354 29.0651 20.354C28.5183 20.354 28.0212 20.4213 27.574 20.5559C27.127 20.6904 26.7495 20.8792 26.4413 21.1223C26.1332 21.3653 25.8878 21.591 25.7057 21.7992C25.5325 21.997 25.3631 22.2274 25.1978 22.4881V20.6533H20.9138L20.9269 21.2783C20.9357 21.6951 20.9401 22.9798 20.9401 25.1324C20.9401 27.2853 20.9314 30.0933 20.914 33.5569H25.1978V26.3563C25.1978 25.9137 25.2453 25.5622 25.341 25.3015C25.5234 24.8586 25.7987 24.4878 26.1679 24.1884C26.5369 23.8887 26.9947 23.739 27.5417 23.739C28.288 23.739 28.8373 23.9972 29.1889 24.5137C29.5404 25.0301 29.7162 25.7441 29.7162 26.6556V33.5565H34V26.1612C33.9997 24.2599 33.5486 22.8169 32.6458 21.832ZM18.5441 20.6533H14.2473V33.5568H18.5441V20.6533Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                stroke: "#EFF4FB"
            })
        ]
    });
};
/* harmony default export */ var linkedIn_social = (LinkedInSocial);

;// CONCATENATED MODULE: ./components/business-share-icons/social-and-share-icon/share.tsx


const MailShare = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 25C22.4295 25.5741 22.9774 26.0491 23.6066 26.3929C24.2357 26.7367 24.9315 26.9411 25.6467 26.9923C26.3618 27.0435 27.0796 26.9403 27.7513 26.6897C28.4231 26.4392 29.0331 26.047 29.54 25.54L32.54 22.54C33.4508 21.597 33.9548 20.3339 33.9434 19.023C33.932 17.712 33.4061 16.4579 32.4791 15.5309C31.5521 14.6038 30.298 14.078 28.987 14.0666C27.676 14.0552 26.413 14.5592 25.47 15.47L23.75 17.18",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26 23.0002C25.5705 22.4261 25.0226 21.951 24.3934 21.6073C23.7642 21.2635 23.0684 21.0591 22.3533 21.0079C21.6382 20.9567 20.9204 21.0599 20.2486 21.3104C19.5769 21.561 18.9668 21.9532 18.46 22.4602L15.46 25.4602C14.5492 26.4032 14.0452 27.6662 14.0566 28.9772C14.068 30.2882 14.5938 31.5423 15.5209 32.4693C16.4479 33.3964 17.702 33.9222 19.0129 33.9336C20.3239 33.945 21.5869 33.441 22.53 32.5302L24.24 30.8202",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                stroke: "#EFF4FB"
            })
        ]
    });
};
/* harmony default export */ var share = (MailShare);

;// CONCATENATED MODULE: ./components/business-share-icons/social-and-share-icon/twitter-social.tsx


const TwitterSocial = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M36 16.5585C35.1075 16.95 34.1565 17.2095 33.165 17.3355C34.185 16.7265 34.9635 15.7695 35.3295 14.616C34.3785 15.183 33.3285 15.5835 32.2095 15.807C31.3065 14.8455 30.0195 14.25 28.6155 14.25C25.8915 14.25 23.6985 16.461 23.6985 19.1715C23.6985 19.5615 23.7315 19.9365 23.8125 20.2935C19.722 20.094 16.1025 18.1335 13.671 15.147C13.2465 15.8835 12.9975 16.7265 12.9975 17.634C12.9975 19.338 13.875 20.8485 15.183 21.723C14.3925 21.708 13.617 21.4785 12.96 21.117C12.96 21.132 12.96 21.1515 12.96 21.171C12.96 23.562 14.6655 25.548 16.902 26.0055C16.5015 26.115 16.065 26.1675 15.612 26.1675C15.297 26.1675 14.979 26.1495 14.6805 26.0835C15.318 28.032 17.127 29.4645 19.278 29.511C17.604 30.8205 15.4785 31.6095 13.1775 31.6095C12.774 31.6095 12.387 31.5915 12 31.542C14.1795 32.9475 16.7625 33.75 19.548 33.75C28.602 33.75 33.552 26.25 33.552 19.749C33.552 19.5315 33.5445 19.3215 33.534 19.113C34.5105 18.42 35.331 17.5545 36 16.5585Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                stroke: "#EFF4FB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(12 12)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var twitter_social = (TwitterSocial);

;// CONCATENATED MODULE: ./components/business-share-icons/business-share-icons.tsx








if (true) {
    window.clipboardData = window.clipboardData || {};
}
const copyToClipboard = (text)=>{
    if ( true && (window === null || window === void 0 ? void 0 : window.clipboardData) && (window === null || window === void 0 ? void 0 : window.clipboardData.setData)) {
        return window === null || window === void 0 ? void 0 : window.clipboardData.setData("Text", text);
    } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand("copy");
        } catch (ex) {
            console.warn("Copy to clipboard failed.", ex);
        } finally{
            document.body.removeChild(textarea);
        }
    }
    return false;
};
const handlePopupCenter = (param)=>{
    let { url , title , popupWidth , popupHeight  } = param;
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    const systemZoom = width / window.screen.availWidth;
    const left = (width - popupWidth) / 2 / systemZoom + dualScreenLeft;
    const top = (height - popupHeight) / 2 / systemZoom + dualScreenTop;
    const newWindow = window.open(url, title, "\n      scrollbars=yes,\n      width=".concat(popupWidth / systemZoom, ", \n      height=").concat(popupHeight / systemZoom, ", \n      top=").concat(top, ", \n      left=").concat(left, "\n      "));
    if (window === null || window === void 0 ? void 0 : window.focus) newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus();
};
const getUrlShare = (type, urlShare)=>{
    switch(type){
        case "facebook":
            return "https://www.facebook.com/sharer.php?u=".concat(urlShare);
        case "linkedIn":
            return "https://www.linkedin.com/sharing/share-offsite/?url=".concat(urlShare);
        case "twitter":
            return "https://twitter.com/intent/tweet?url=".concat(urlShare);
        case "mail":
            return "mailto:?body=".concat(urlShare);
        default:
            return urlShare;
    }
};
const getTooltipMessage = (type)=>{
    switch(type){
        case "facebook":
            return "Share on Facebook";
        case "linkedIn":
            return "Share on LinkedIn";
        case "twitter":
            return "Share on Twitter";
        case "mail":
            return "Click to copy";
        default:
            return "Click to copy";
    }
};
const socialAndShares = [
    {
        type: "facebook",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook_social, {})
    },
    {
        type: "linkedIn",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedIn_social, {})
    },
    {
        type: "twitter",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter_social, {})
    },
    {
        type: "copy",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(share, {})
    }
];
const SocialAndShare = (props)=>{
    const [isCopied, setIsCopied] = react.useState(false);
    const { shareUrl =""  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_share_icons_module_default()).businessSocialAndShareContainer,
        children: (socialAndShares || []).map((item)=>{
            const linkShare = getUrlShare(item.type, item.urlShare || shareUrl);
            if (item.type === "copy") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CopyToClipboard, {
                    text: linkShare,
                    onCopy: ()=>{
                        setIsCopied(true);
                        setTimeout(()=>{
                            setIsCopied(false);
                        }, 3000);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_share_icons_module_default()).businessSocialAndShareLink,
                        children: [
                            item.compShare,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (business_share_icons_module_default()).businessSocialAndShareTooltip,
                                children: isCopied ? "Copied" : getTooltipMessage(item.type)
                            })
                        ]
                    }, item.type)
                }, item.type);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_share_icons_module_default()).businessSocialAndShareLink,
                onClick: ()=>{
                    item.type === "copy" ? copyToClipboard(linkShare) : handlePopupCenter({
                        url: linkShare,
                        title: getTooltipMessage(item.type),
                        popupWidth: 400,
                        popupHeight: 300
                    });
                },
                children: [
                    item.compShare,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (business_share_icons_module_default()).businessSocialAndShareTooltip,
                        children: getTooltipMessage(item.type)
                    })
                ]
            }, item.type);
        })
    });
};
/* harmony default export */ var business_share_icons = (SocialAndShare);


/***/ }),

/***/ 3510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5008);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8470);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7883);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(298);
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1082);
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hook_useWindowSize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8766);
/* harmony import */ var _article_card_article_card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2790);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3203);
/* harmony import */ var _related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8819);
/* harmony import */ var _related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9__);









swiper__WEBPACK_IMPORTED_MODULE_6__/* ["default"].use */ .Z.use([
    swiper__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
    swiper__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z
]);
const RelatedArticles = (props)=>{
    const { title , description , viewAllSeriesText , viewAllSeriesUrl , articles  } = props.relatedArticles;
    const prevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const nextRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const windowSize = (0,_hook_useWindowSize__WEBPACK_IMPORTED_MODULE_3__/* .useWindowSize */ .i)();
    const navigationConfig = {
        prevEl: prevRef.current ? prevRef.current : undefined,
        nextEl: nextRef.current ? nextRef.current : undefined
    };
    const isMobileOrTablet = ()=>{
        const windowWidth = windowSize.width || 0;
        if (windowWidth < 1440) {
            return true;
        } else {
            return false;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().relatedArticlesContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().relatedArticlesHeader),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().relatedArticlesHeaderInfo),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().relatedArticlesHeaderTitle),
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().relatedArticlesHeaderDescription),
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        href: viewAllSeriesUrl,
                        target: "_self",
                        className: (_related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().relatedArticlesViewAll),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: viewAllSeriesText
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                type: _icons__WEBPACK_IMPORTED_MODULE_5__/* .IconType.ArrowRightMedium */ .T.ArrowRightMedium
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().relatedArticleSlider),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: nextRef,
                        className: (_related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().swiperButtonNext),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            type: _icons__WEBPACK_IMPORTED_MODULE_5__/* .IconType.ArrowRightMedium */ .T.ArrowRightMedium
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: prevRef,
                        className: (_related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().swiperButtonPrev),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            type: _icons__WEBPACK_IMPORTED_MODULE_5__/* .IconType.ArrowRightMedium */ .T.ArrowRightMedium
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_10__/* .Swiper */ .t, {
                        navigation: navigationConfig,
                        onInit: (swiper)=>{
                            if (!swiper) {
                                return;
                            }
                            const navigation = swiper === null || swiper === void 0 ? void 0 : swiper.params.navigation;
                            navigation.prevEl = prevRef.current;
                            navigation.nextEl = nextRef.current;
                            swiper.navigation.update();
                        },
                        slidesPerView: "auto",
                        spaceBetween: isMobileOrTablet() ? 8 : 24,
                        centeredSlides: true,
                        centeredSlidesBounds: true,
                        watchOverflow: true,
                        lazy: {
                            loadPrevNext: true,
                            loadPrevNextAmount: 1
                        },
                        updateOnWindowResize: true,
                        className: (_related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().relatedArticleSliderSeoSeriesSlider),
                        children: (articles || []).map((article)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_11__/* .SwiperSlide */ .o, {
                                className: (_related_articles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().relatedArticleSlide),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_article_card_article_card__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_4__/* .ArticleCardType.Small */ ._.Small,
                                    article: article
                                })
                            }, article.articleUrl);
                        })
                    }, title)
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RelatedArticles);


/***/ }),

/***/ 4189:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backToLatestArticle":"back-to-latest-article_backToLatestArticle__dq733"};

/***/ }),

/***/ 8737:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessArticleBioContainer":"business-article-bio-block_businessArticleBioContainer__Z4D3H","businessArticleAuthorAvatar":"business-article-bio-block_businessArticleAuthorAvatar__rGfc5","businessArticleLeadImage":"business-article-bio-block_businessArticleLeadImage__VB0bw","businessArticleInfo":"business-article-bio-block_businessArticleInfo__aGWSK","writtenBy":"business-article-bio-block_writtenBy__F9tnK","name":"business-article-bio-block_name__n83k4","bio":"business-article-bio-block_bio__gJMAS"};

/***/ }),

/***/ 7053:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleCategoriesContainer":"business-article-categories-block_articleCategoriesContainer__oJHfl","categoriesHeading":"business-article-categories-block_categoriesHeading__eQWJ9","light":"business-article-categories-block_light___amCM"};

/***/ }),

/***/ 2288:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessArticleContributorListContainer":"business-article-contributor-block_businessArticleContributorListContainer__o_0Ol","hasAuthorBefore":"business-article-contributor-block_hasAuthorBefore__sWYoh","businessArticleContributorContainer":"business-article-contributor-block_businessArticleContributorContainer__B_s25","businessArticleContributorAvatar":"business-article-contributor-block_businessArticleContributorAvatar__vqZD0","businessArticleLeadImage":"business-article-contributor-block_businessArticleLeadImage__uB3dI","businessArticleInfo":"business-article-contributor-block_businessArticleInfo__Xy5Ux","writtenBy":"business-article-contributor-block_writtenBy__YSWO_","name":"business-article-contributor-block_name__WQxel","bio":"business-article-contributor-block_bio__vNW5Z","cta":"business-article-contributor-block_cta__k0VDh"};

/***/ }),

/***/ 6908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessSocialAndShareContainer":"business-share-icons_businessSocialAndShareContainer__R7gfs","businessSocialAndShareLink":"business-share-icons_businessSocialAndShareLink__kFJ96","businessSocialAndShareTooltip":"business-share-icons_businessSocialAndShareTooltip__M7ME6"};

/***/ }),

/***/ 8819:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"relatedArticlesContainer":"related-articles_relatedArticlesContainer__8fKeY","relatedArticlesHeader":"related-articles_relatedArticlesHeader__U8b_D","relatedArticlesViewAll":"related-articles_relatedArticlesViewAll__yDZYg","relatedArticlesHeaderTitle":"related-articles_relatedArticlesHeaderTitle__z4RWz","relatedArticlesHeaderDescription":"related-articles_relatedArticlesHeaderDescription__Qe6Fp","relatedArticleSlider":"related-articles_relatedArticleSlider__poR0G","swiperButtonNext":"related-articles_swiperButtonNext__Msilu","swiperButtonPrev":"related-articles_swiperButtonPrev__7RIGR","relatedArticleSlide":"related-articles_relatedArticleSlide__KXA_i","video-spin":"related-articles_video-spin__76pd_"};

/***/ })

}]);